function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleReception3Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.863 12.393h2V8.698h-2v3.695zm-4.073-1.796l2.83 2.375-1.285 1.532-2.83-2.375 1.285-1.532zm5.073 11.258a3.162 3.162 0 00-2.992 2.153h5.983a3.16 3.16 0 00-2.991-2.153zm1-3.696v1.797a5.165 5.165 0 014.053 4.052h.864v2h-28v-2h1.052c.252-3.158 1.669-5.962 3.844-7.467a.999.999 0 111.138 1.644c-1.627 1.126-2.746 3.344-2.986 5.823h10.636c-.24-2.48-1.36-4.697-2.987-5.823a.999.999 0 01-.252-1.391.998.998 0 011.39-.253c2.176 1.505 3.593 4.309 3.844 7.467h1.35a5.165 5.165 0 014.054-4.052v-1.797h-2v-2h6v2h-2zm4.072-7.562l1.285 1.532-2.83 2.375-1.285-1.532 2.83-2.375zM10.146 7.992a2.918 2.918 0 012.914 2.914 2.918 2.918 0 01-2.914 2.914 2.918 2.918 0 01-2.914-2.914 2.918 2.918 0 012.914-2.914zm0 7.828a4.919 4.919 0 004.914-4.914 4.92 4.92 0 00-4.914-4.914 4.92 4.92 0 00-4.914 4.914 4.919 4.919 0 004.914 4.914z",
    fill: props.color
  }));
}

export default SvgIconPeopleReception3Filled;